export default __webpack_public_path__ + "static/media/npm-original-wordmark.a859e158.svg";